// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2V4ro","buttons":"PendingPaymentAlert_buttons__3we_2"};